"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withClientInfo = void 0;
/**
 * This function adds provided headers into request
 * and could be used as a wrapper of endpoint's constructRequest
 * @param constructRequest construct request function
 * @param clientInfoHeaders common headers to append into request
 * @returns
 */
function withClientInfo(constructRequest, commonHeaders) {
    return commonHeaders
        ? (...args) => {
            const request = constructRequest(...args);
            return {
                ...request,
                headers: {
                    ...commonHeaders,
                    ...request.headers,
                },
            };
        }
        : constructRequest;
}
exports.withClientInfo = withClientInfo;
